import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  input,
  output
} from '@angular/core';
import { MatOption } from '@angular/material/core';
import { FloatLabelType, MatFormField, MatLabel } from '@angular/material/form-field';

import { MatSelect } from '@angular/material/select';

@Component({
    selector: 'mulo-facet-sort',
    templateUrl: './facet-sort.component.html',
    styleUrls: ['./facet-sort.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'mulo-facet-sort' },
    imports: [
        MatFormField,
        MatLabel,
        MatSelect,
        MatOption
    ]
})
export class FacetSortComponent implements OnInit {
  readonly label = input('Sort by');
  readonly options = input<MatOption[]>([]);
  readonly selected = input<string>(undefined);
  readonly selectedChange = output<string>();

  floatLabel: FloatLabelType = 'auto';

  constructor() {}

  ngOnInit(): void {}

  onValueChange(value) {
    this.selectedChange.emit(value);
  }
}
